module.exports = __webpack_public_path__ + "static/media/info-apartment.5d9b9b4e.jpg";